export class TriggerConfigheaders {
  hvalue: string;
  hkey: string;
}
